<template>
  <v-container>
    <v-breadcrumbs :items="breadcrumbs" class="pl-0 py-1">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>

    <v-card class="mt-3 mb-4">
      <v-data-table
        :headers="headersGroup"
        :items="[group_data]"
        item-key="name"
        class="elevation-1"
        hide-default-footer
        :items-per-page="-1"
        :loading="loadingMember"
        loading-text="ローディング..."
        no-data-text="該当データがありません。"
      >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>
            <b>詳細情報</b>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn v-if="checkOwner()" color="primary" dark class="mb-2" @click="editGroup">
            <v-icon left>mdi-pencil</v-icon>編集
          </v-btn>
        </v-toolbar>
        <v-divider></v-divider>
      </template>
      <template v-slot:item.first_name="{item}">
        {{ item.last_name }} {{ item.first_name }}
      </template>
      <template v-slot:item.status="{item}">
        <v-chip
          class="ma-2"
          color="green"
          text-color="white"
          v-if="item.status=='ACTIVE'"
        >
          有効
        </v-chip>
        <v-chip
          class="ma-2"
          color="red"
          text-color="white"
          v-if="item.status=='DEACTIVE'"
        >
          無効
        </v-chip>
      </template>
      </v-data-table>
    </v-card>

    <v-card v-if="checkOwner()" class="mt-3 mb-4">
      <v-data-table
        :headers="headersMember"
        :items="members"
        item-key="name"
        class="elevation-1"
        hide-default-footer
        :items-per-page="-1"
        :loading="loadingMember"
        loading-text="ローディング..."
        no-data-text="該当データがありません。"
      >
      <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>
              <b>メンバー一覧</b>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn v-if="checkOwner()" color="primary" dark class="mb-2" @click="editMember">
              <v-icon left>mdi-pencil</v-icon>編集
            </v-btn>
          </v-toolbar>
      </template>
      <template v-slot:item.first_name="{item}">
        {{ item.last_name }} {{ item.first_name }}
      </template>
      <template v-slot:item.id="{item}">
        {{ getTextRoleMember(item.id, owner.id) }}
      </template>
      </v-data-table>
    </v-card>

    <v-card class="mt-3 mb-4">
      <v-data-table
        :headers="headersPlant"
        :items="plants"
        item-key="name"
        class="elevation-1"
        hide-default-footer
        :items-per-page="-1"
        :loading="loadingPlant"
        loading-text="ローディング..."
        no-data-text="該当データがありません。"
      >
      <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>
              <b>発電所一覧</b>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
      </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import {store} from '../store';

export default {
  name: "Detail",
  data() {
    return {
        group_id: this.$route.params.groupId,
        group_data: {
          name: null,
          username: null,
          email: null,
        },
        role: localStorage.getItem('drs_role'),
        user: localStorage.getItem('drs_user'),
        loadingPlant: true,
        plants: [],
        headersPlant: [
            {
                text: '経産省ID',
                value: 'ministry_id',
            },
            {
                text: '発電所名',
                value: 'name',
            },
            {
                text: '住所',
                value: 'address',
            },
        ],

        loadingMember: true,
        members: [],
        owner: {
          id: null,
          email: null,
        },
        headersMember: [
          {
            text: 'メールアドレス',
            value: 'email',
          },
          {
            text: '名前',
            value: 'first_name',
          },
          {
            text:'権限',
            value:'id',
          },
        ],

        allPlants:null,
        breadcrumbs: [
          {
              text: "グループ",
              disabled: false,
              exact: true,
              to: "/group"
          },
          {
              text: "",
              disabled: false,
              exact: true,
          },
        ],
        headersGroup: [
          {
            text: 'グループ名',
            value: 'name',
            sortable: false,
          },
          {
            text: 'オーナー',
            value: 'first_name',
            sortable: false,
          },
          {
            text:'状況',
            value:'status',
            align: 'center',
            sortable: false,
          },
        ],
    }
  },

  methods: {
    resetDataPlant() {
        this.loadingPlant = true;
        this.plants = [];
    },

    getPlants() {
      this.resetDataPlant();
      this.axios.get("/api/group/plants/"+ this.group_id)
      .then((response) => {
          this.loadingPlant = false;
          this.plants = response.data.plants;
          this.breadcrumbs[1].text = response.data.group.name;
      })
      .catch(() => {
          store.showErrorDialog("エラーが発生しました。再度試してください。");
      });
    },
    resetDataMember() {
      this.loadingMember = true;
      this.members = [];
    },
    arraymove(arr, fromIndex, toIndex) {
      var element = arr[fromIndex];
      arr.splice(fromIndex, 1);
      arr.splice(toIndex, 0, element);
    },

    getMembers() {
      this.members = [];
      this.axios.get("/api/group/members/"+ this.group_id)
      .then((response) => {
        this.loadingMember = false;
        this.group_data = response.data;
        this.members = response.data.members;
        this.owner.id = response.data.owner;
        this.owner.email = response.data.email;
        const member_index =  this.members.findIndex(x => x.id == response.data.owner)
        this.arraymove(this.members, member_index, 0);
      })
      .catch(() => {
        store.showErrorDialog("エラーが発生しました。再度試してください。");
      });
    },

    getTextRoleMember(member_id, user_id) {
      if (user_id == member_id) {
        return "オーナー";
      } else {
        return "メンバー";
      }
    },

    editMember() {
      this.$router.push('/group/'+ this.group_id+ '/editmember');
    },
    editGroup() {
      this.$router.push('/group/' + this.group_id+ '/edit' );
    },
    checkOwner() {
      if(this.user == this.owner.email || this.role == "ADMIN") {
        return true;
      }
      return false;
    },

  },

  created() {
    this.getPlants();
    this.getMembers();
  },
}
</script>

<style scoped>
>>>.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
    border-bottom: none;
}

</style>
